import React, { FC } from 'react';
import { MediaUploaderDropPlace } from '../_DropPlace/MediaUploaderDropPlace';
import { MediaUploaderSingleFile } from './_SingleFile/MediaUploaderSingleFile';
import { DropzoneState } from 'react-dropzone';
import { TMediaUploaderPreviewMode } from '../models';
import { IMediaImageResizeOption } from '@src/models/entity';
import { IMediaUploaderFile } from '../MediaUploaderController';

interface ISingleContainerProps {
  dropzone: DropzoneState;
  previewMode: TMediaUploaderPreviewMode;
  previewSize: IMediaImageResizeOption | undefined;
  isDropPlaceGrey: boolean | undefined;
  value: IMediaUploaderFile[];
  greyscale: boolean;
  showFileInfo: boolean;
  onLoadedSingleImage: (() => void) | undefined;
  showDeleteButton: boolean;
}

export const SingleContainer: FC<ISingleContainerProps> = ({
  dropzone,
  previewMode,
  previewSize,
  isDropPlaceGrey,
  value,
  greyscale,
  showFileInfo,
  onLoadedSingleImage,
  showDeleteButton,
}) => {
  if (value[0]) {
    return (
      <MediaUploaderSingleFile
        dropzone={dropzone}
        previewMode={previewMode}
        previewSize={previewSize}
        file={value[0]}
        greyscale={greyscale}
        showFileInfo={showFileInfo}
        onLoadImage={onLoadedSingleImage}
        showDeleteButton={showDeleteButton}
      />
    );
  }

  return (
    <MediaUploaderDropPlace
      dropzone={dropzone}
      previewMode={previewMode}
      previewSize={previewSize}
      isDropPlaceGrey={isDropPlaceGrey}
    />
  );
};
